import * as Yup from 'yup';
export const RegistrationvalidationSchema = Yup.object().shape({
    name: Yup.string().required('Participant Name is required'),
    fatherName: Yup.string().required('Father’s Name is required'),
    previousInstitution: Yup.string().required('Previous Institution is required'),
  intermediateMarks: Yup.number()
    .typeError('Marks must be a number')
    .min(0, 'Cannot be negative')
    .max(99, 'Cannot exceed two digits')
    .nullable()
    .notRequired(),
    mobile: Yup.string()
        .matches(/^[0-9]{10}$/, 'Must be a valid 10-digit number')
        .required('Contact Number is required'),
    aadhaarNo: Yup.string()
        .matches(/^[0-9]{12}$/, 'Must be a valid 12-digit Aadhaar number')
        .required('Aadhaar Number is required'),

    declaration: Yup.boolean()
        .oneOf([true], 'You must accept the declaration to proceed'),
});
